export default {
  CtmInformation__SWABIZ: "SWABIZ",
  CtmInformation__TRAVEL_MANAGER_ACCOUNT: "Travel Manager account",
};
